<template>
  <v-container grid-list-md page>
    <v-layout row wrap>
      <v-flex xs12 md9>
        <h1 class="title primary--text my-3">人気曲ランキング</h1>
      </v-flex>
      <v-flex xs12 md3>
        <v-select
          v-model="selectedScene"
          :items="$store.state.searchTuneOption.scenesRanking"
          item-text="sceneName"
          item-value="id"
          label="シーンを選択"
          @change="changeScenes"
        >
        </v-select>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <RankingList :sceneId=selectedSceneValue></RankingList>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import RankingList from '@/components/RankingList.vue'
export default {
  name: 'Ranking',
  components: {
    RankingList
  },
  data () {
    return {
      selectedScene: { id: 0, sceneName: '総合ランキング', avatar: '' },
      selectedSceneValue: null
    }
  },
  methods: {
    changeScenes (val) {
      // ranking-list にシーンIDを送る
      this.selectedSceneValue = val
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/home/Ranking.vue